import {
    Button,
    Dialog as MuiDialog,
    DialogContent,
    DialogProps as MuiDialogProps,
    DialogTitle,
    useTheme,
    Box
} from "@material-ui/core";
  import React from 'react'  

  
  export const Survey = ({
    onConfirm,
    onCancel,
    show = true,
    title = 'Please confirm',
    confirmButtonText = 'OK',
    cancelButtonText = 'Cancel',
    ...props
  }) => (
    <MuiDialog open={show} onClose={onCancel} {...props} maxWidth='xs'>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent style={{ fontSize: useTheme().typography.body2.fontSize }} >
        <Box>
         We have a few questions about your experience of using TGE OD Web Portal.
       </Box>
       <Box paddingTop={1}>
         It would only take a couple of minutes. Your feedback is important to us.
       </Box>
       <Box paddingTop={2} style={{display:'flex', justifyContent:'center'}}>
            Click Yes to participate
        </Box>
        <Box paddingTop={1} style={{display:'flex', justifyContent:'center'}}>
          <Button color='primary' variant='contained' onClick={onConfirm} style={{width:'200px'}}>
            {confirmButtonText}
          </Button>
        </Box>
        <Box paddingTop={2} style={{display:'flex', justifyContent:'center'}}>
            Click No to skip or if you have already filled the survey
        </Box>
        <Box paddingTop={1} style={{display:'flex', justifyContent:'center'}} >
          <Button color='primary' variant='contained' onClick={onCancel} style={{width:'200px'}}>
            {cancelButtonText}
          </Button>
        </Box>
        <Box paddingTop={2} paddingBottom={1}>
            The survey will be available until 16th December 6pm.
       </Box>
      </DialogContent>
    </MuiDialog>
  )
  
  export default Survey
  